import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { RoutesNames } from "../../../routes/enum";
import { CButton } from "../../common";

const FourthSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { sm, lg } = Grid.useBreakpoint();

    const goToRegistration = () => navigate(`${RoutesNames.LOGIN}/${RoutesNames.REGISTRATION}`);

    return (
        <Container>
            <div className="view-container">
                <div className="left-view">
                    <div className="left-view-title">
                        {sm ? (
                            <img src="/images/landing_arrow.svg" alt="arrow" />
                        ) : (
                            <svg
                                width="50"
                                height="237"
                                viewBox="0 0 50 237"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M36.7061 236.471C37.5187 236.633 38.3083 236.105 38.4697 235.292L41.1007 222.051C41.2622 221.239 40.7344 220.449 39.9218 220.288C39.1093 220.126 38.3197 220.654 38.1583 221.466L35.8196 233.236L24.0497 230.898C23.2371 230.736 22.4476 231.264 22.2861 232.077C22.1246 232.889 22.6525 233.679 23.465 233.84L36.7061 236.471ZM36.9985 235C38.2455 234.166 38.2455 234.166 38.2456 234.166C38.2456 234.166 38.2456 234.166 38.2456 234.166C38.2456 234.166 38.2456 234.167 38.2456 234.167C38.2457 234.167 38.2456 234.167 38.2456 234.166C38.2455 234.166 38.2452 234.166 38.2448 234.165C38.244 234.164 38.2427 234.162 38.2409 234.159C38.2371 234.154 38.2312 234.145 38.2232 234.133C38.2071 234.108 38.1825 234.071 38.1496 234.021C38.0838 233.92 37.985 233.769 37.8554 233.566C37.5962 233.162 37.2139 232.557 36.7264 231.761L34.1681 233.328C34.6667 234.142 35.06 234.765 35.3299 235.186C35.4649 235.396 35.569 235.556 35.64 235.665C35.6755 235.719 35.7027 235.76 35.7214 235.788C35.7307 235.802 35.7379 235.813 35.7429 235.821C35.7454 235.825 35.7474 235.827 35.7488 235.83C35.7495 235.831 35.7501 235.832 35.7505 235.832C35.7508 235.833 35.7509 235.833 35.7511 235.833C35.7512 235.833 35.7512 235.833 35.7513 235.833C35.7513 235.833 35.7514 235.833 35.7514 235.833C35.7514 235.833 35.7514 235.834 36.9985 235ZM33.7131 226.623C32.8446 225.084 31.8792 223.324 30.8425 221.359L28.189 222.758C29.2395 224.75 30.2184 226.535 31.1003 228.098L33.7131 226.623ZM28.1454 216.081C27.3099 214.394 26.4471 212.602 25.5672 210.711L22.8472 211.976C23.7377 213.89 24.6111 215.704 25.4571 217.413L28.1454 216.081ZM23.1162 205.274C22.3455 203.509 21.5691 201.675 20.7932 199.776L18.0161 200.911C18.8012 202.832 19.5869 204.688 20.3668 206.474L23.1162 205.274ZM18.5985 194.218C17.9036 192.395 17.214 190.521 16.5342 188.6L13.7061 189.601C14.3941 191.545 15.092 193.441 15.7952 195.286L18.5985 194.218ZM14.6238 182.987C14.0177 181.133 13.4238 179.241 12.8457 177.312L9.97201 178.174C10.5575 180.127 11.1588 182.043 11.7723 183.92L14.6238 182.987ZM11.2051 171.577C10.6876 169.677 10.1875 167.746 9.70792 165.785L6.79383 166.498C7.27972 168.484 7.78632 170.441 8.3105 172.365L11.2051 171.577ZM8.3747 160.005C7.95875 158.086 7.56414 156.142 7.19354 154.174L4.24536 154.729C4.62113 156.724 5.02117 158.695 5.44276 160.641L8.3747 160.005ZM6.17082 148.291C5.86172 146.351 5.57736 144.39 5.32016 142.411L2.34516 142.797C2.60616 144.806 2.89465 146.795 3.20818 148.763L6.17082 148.291ZM4.6413 136.505C4.44497 134.54 4.27667 132.558 4.13861 130.56L1.14574 130.767C1.28596 132.796 1.45685 134.808 1.65616 136.803L4.6413 136.505ZM3.82158 124.634C3.74724 122.666 3.70344 120.685 3.69218 118.691L0.692221 118.708C0.703668 120.734 0.748193 122.748 0.823717 124.747L3.82158 124.634ZM3.75655 112.728C3.81026 110.765 3.89666 108.792 4.01759 106.81L1.02315 106.627C0.900145 108.644 0.812288 110.65 0.757668 112.645L3.75655 112.728ZM4.48168 100.877C4.66908 98.9174 4.89139 96.9493 5.15034 94.9739L2.17579 94.5839C1.91222 96.5946 1.68599 98.5975 1.4953 100.592L4.48168 100.877ZM6.02543 89.1066C6.3516 87.1582 6.7146 85.2036 7.11605 83.2437L4.17708 82.6417C3.76827 84.6374 3.39867 86.6276 3.06661 88.6113L6.02543 89.1066ZM8.40729 77.4734C8.87269 75.5575 9.37602 73.6374 9.91881 71.7141L7.03157 70.8993C6.47871 72.8583 5.96605 74.814 5.49207 76.7652L8.40729 77.4734ZM11.6325 66.0419C12.2355 64.1709 12.8771 62.2975 13.5585 60.4225L10.739 59.3977C10.0449 61.3076 9.39139 63.2158 8.77716 65.1217L11.6325 66.0419ZM15.6907 54.8757C16.4274 53.0594 17.2027 51.2422 18.018 49.4248L15.2809 48.1969C14.4506 50.0475 13.6609 51.8982 12.9106 53.7482L15.6907 54.8757ZM20.555 44.0338C21.4192 42.2803 22.3218 40.5272 23.2639 38.7752L20.6217 37.3544C19.6628 39.1376 18.7439 40.9223 17.864 42.7076L20.555 44.0338ZM26.184 33.5675C27.168 31.8826 28.1898 30.1992 29.2503 28.5179L26.7129 26.9174C25.6342 28.6275 24.5947 30.3401 23.5934 32.0546L26.184 33.5675ZM32.5242 23.5176C33.6198 21.9042 34.7522 20.2933 35.9223 18.6853L33.4966 16.9201C32.3074 18.5543 31.1562 20.1919 30.0423 21.8323L32.5242 23.5176ZM39.5148 13.912C40.7141 12.3703 41.9493 10.8318 43.2211 9.2968L40.911 7.38275C39.6197 8.9413 38.3652 10.5039 37.1469 12.07L39.5148 13.912ZM47.0928 4.76518C47.7562 4.01178 48.4287 3.25935 49.1105 2.50796L46.8887 0.492082C46.197 1.25446 45.5145 2.01798 44.8412 2.7826L47.0928 4.76518Z"
                                    fill="#CECECE"
                                />
                            </svg>
                        )}

                        <h1>
                            <span>{t("Our")}</span> {t("doctors")}
                        </h1>
                        <span>
                            {t(
                                "Choose your doctor according to your needs. Our platform will help you find the perfect specialist for your health."
                            )}
                        </span>
                        <CButton
                            width={lg ? "292px" : "200px"}
                            align="flex-start"
                            onClick={goToRegistration}
                        >
                            {t("Choose a doctor")}
                        </CButton>
                    </div>
                </div>
                <div className="phone-view">
                    <img width={650} src="/images/chose_doctor.svg" alt="phone" />
                    <img className="doctor-image" src="/images/doctor.svg" alt="doctor" />
                </div>
            </div>
        </Container>
    );
};

export default FourthSection;

const Container = styled.div`
    width: 100%;
    display: flex;
    background-color: #fff;
    height: 97vh;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;

    .view-container {
        max-width: 1140px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .left-view {
        width: 50%;
        padding: 20px;

        .left-view-title {
            display: flex;
            flex-direction: column;
            gap: 15px;
            position: relative;

            & > img {
                position: absolute;
                top: -193px;
                right: -30px;
            }

            & > h1 {
                color: #212121;
                font-family: "Raleway";
                font-size: 50px;
                font-style: normal;
                font-weight: 800;
                line-height: normal;
                span {
                    color: #1677ff;
                    font-weight: 800;
                }
            }
            & > span {
                color: #787878;
                font-family: "Roboto";
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 140%; /* 25.2px */
                max-width: 450px;
            }
        }
    }

    .phone-view {
        position: relative;
        width: 50%;
        padding: 20px;

        .doctor-image {
            position: absolute;
            bottom: 205px;
            left: -90px;
            max-width: 500px;
        }
    }

    @media (max-width: 770px) {
        height: auto;

        .left-view {
            padding: 55px;

            .left-view-title {
                display: flex;
                flex-direction: column;
                gap: 15px;
                position: relative;

                & > img {
                    z-index: 10;
                    right: -190px;
                    top: -205px;
                }

                & > h1 {
                    font-size: 28px;
                }
                & > span {
                    font-size: 14px;
                }
            }
        }

        .phone-view {
            position: relative;
            width: 100%;
            padding: 0;

            img {
                width: 100%;
            }

            .doctor-image {
                position: absolute;
                bottom: 205px;
                left: 0;
                max-width: 315px;
            }
        }
    }

    @media (max-width: 450px) {
        height: auto;

        .view-container {
            flex-direction: column;
        }

        .left-view {
            width: 85%;
            padding: 20px;

            .left-view-title {
                display: flex;
                flex-direction: column;
                gap: 15px;
                position: relative;

                & > svg {
                    position: absolute;
                    top: 150px;
                    left: 0;
                    max-height: 115px;
                    z-index: 12;
                }

                & > h1 {
                    font-size: 24px;
                    span {
                        color: #1677ff;
                        font-weight: 800;
                    }
                }
                & > span {
                    font-size: 13px;
                }
            }
        }

        .phone-view {
            position: relative;
            width: 100%;
            padding: 0;

            img {
                width: 100%;
            }

            .doctor-image {
                position: absolute;
                bottom: 205px;
                left: 0;
                max-width: 315px;
            }
        }
    }
`;
